import { Link } from "react-router-dom";
import { CommerceDemo } from "../components/CommerceDemo";
import { ConversationStory } from "../components/ConversationStory";
import { ProductDemo } from "../components/ProductDemo";
import { productCapabilities } from "../content";

const CHAT_URL = "https://chat.hellomarky.com/";

export function ChatPage() {
  return (
    <main id="main-content" className="interior-world chat-world">
      <section className="chat-launch-hero">
        <div className="chat-launch-copy">
          <p className="route-kicker" data-hero-support>Hello Marky Chat</p>
          <h1>
            <span data-hero-line><span>One conversation.</span></span>
            <span data-hero-line><span>The whole business behind it.</span></span>
          </h1>
          <p data-hero-support>Useful answers, commerce actions, lead capture, and human handoff in one connected product.</p>
          <div className="hero-actions" data-hero-support>
            <a className="world-button" href={CHAT_URL} target="_blank" rel="noreferrer">Try the product <span aria-hidden="true">↗</span></a>
            <Link className="world-text-link" to="/work/hello-marky-chat">Read the build story</Link>
          </div>
        </div>
        <div className="chat-portal-stage" aria-label="Marky moving through a connected conversation portal">
          <div className="portal-halo" aria-hidden="true" />
          <img src="/visuals/marky-chat-portal.webp" alt="Marky inside a dimensional conversation portal with knowledge and handoff objects" width="1122" height="1402" fetchPriority="high" data-route-object />
        </div>
      </section>

      <section className="chat-product-stage">
        <div className="chat-product-intro" data-reveal>
          <h2>The product is the proof.</h2>
          <p>Switch channels, replay the exchange, and see how useful context remains attached.</p>
        </div>
        <div className="chat-product-demo" data-clip-reveal><ProductDemo compact /></div>
      </section>

      <section className="chat-truth chat-truth--world">
        <h2 data-reveal>An answer is only useful when the next action survives.</h2>
        <p data-reveal>Hello Marky Chat knows the business, remembers the conversation, captures the right details, and makes human takeover feel natural.</p>
      </section>

      <ConversationStory />

      <section className="chat-commerce-world">
        <div className="chat-commerce-copy" data-reveal>
          <h2>A shopper speaks naturally. The system still acts accurately.</h2>
          <p>Marky finds products, presents options, builds a cart, and keeps checkout clear across web and supported social channels.</p>
          <Link className="inline-route" to="/work/conversation-commerce">Open the commerce execution <span aria-hidden="true">↗</span></Link>
        </div>
        <div className="chat-commerce-demo" data-clip-reveal><CommerceDemo /></div>
      </section>

      <section className="chat-capability-field">
        <header data-reveal>
          <h2>Already inside the product.</h2>
          <p>These are working capabilities represented in the Hello Marky Chat codebase.</p>
        </header>
        <div className="chat-capability-grid">
          {productCapabilities.map((item, index) => (
            <article key={item} data-reveal>
              <span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
              <p>{item}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="chat-principle-band" aria-label="Product principle">
        <p data-drift-line>AI-assisted. Human when it matters.</p>
      </section>

      <section className="interior-close">
        <img src="/brand/marky-dark.svg" alt="" aria-hidden="true" />
        <h2>See what a calmer customer conversation feels like.</h2>
        <a className="world-button" href={CHAT_URL} target="_blank" rel="noreferrer">Try the product <span aria-hidden="true">↗</span></a>
      </section>
    </main>
  );
}
